import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '@services/common.service';
import { ChainEnum } from '@src/app/shared/types/wallet-chain.type';
import { finalize } from 'rxjs/operators';
import { MemeDashboardService } from '../../meme-dashboard.service';
import { WatchlistAgentInfo, WatchlistTGAlert } from '../../meme-dashboard.type';
@Component({
    selector: 'app-watchlist-detail',
    templateUrl: './watchlist-detail.component.html',
    styleUrls: ['./watchlist-detail.component.less'],
})
export class WatchlistDetailComponent implements OnInit {
    watchlistId: number;
    watchlistAgentInfo: WatchlistAgentInfo;

    recentTgAlerts: WatchlistTGAlert[] = [];
    fetchingRecentTgAlerts = false;

    chain: any = ChainEnum.BASE;

    constructor(private activatedRoute: ActivatedRoute, private memeDashboardService: MemeDashboardService, private commonService: CommonService) {}

    ngOnInit() {
        this.watchlistId = Number(this.activatedRoute.snapshot.params['watchlist_id']);

        this.memeDashboardService.getWatchlistAgentDetail(this.watchlistId).subscribe({
            next: res => (this.watchlistAgentInfo = res),
            error: err => this.commonService.errorMessageByResponse(err),
        });

        this.fetchAlerts();
    }

    fetchAlerts() {
        this.fetchingRecentTgAlerts = true;
        this.recentTgAlerts = [];
        this.memeDashboardService
            .getRecentWatchlistTGAlerts(this.watchlistId, this.chain)
            .pipe(finalize(() => (this.fetchingRecentTgAlerts = false)))
            .subscribe(res => (this.recentTgAlerts = res.data));
    }
}
